(() => {
  // The Shopify Meta app pixel only maps commerce events, so the signup reports
  // CompleteRegistration itself once per page view: from the browser pixel (email
  // as advanced matching, hashed by fbevents) and from the Conversions API relay
  // with the same event ID, so Meta deduplicates and still counts visitors whose
  // browser blocks the pixel. Both follow Shopify's marketing consent: the pixel
  // only loads with it, and the relay call checks it explicitly.
  const CAPI_RELAY = 'https://gr-bg-signup-relay.vercel.app/api/registration';
  let registrationTracked = false;
  function readCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : undefined;
  }
  function sendServerRegistration(eventId, email, params) {
    const send = () => {
      if (!window.Shopify.customerPrivacy.marketingAllowed()) return;
      const fbclid = new URLSearchParams(location.search).get('fbclid');
      navigator.sendBeacon(CAPI_RELAY, new Blob([JSON.stringify({
        event_id: eventId,
        email,
        event_source_url: location.href,
        fbp: readCookie('_fbp'),
        fbc: readCookie('_fbc') || (fbclid ? `fb.1.${Date.now()}.${fbclid}` : undefined),
        content_name: params.content_name,
        content_category: params.content_category
      })], {type: 'text/plain'}));
    };
    if (window.Shopify?.customerPrivacy) return send();
    window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], (error) => { if (!error) send(); });
  }
  function trackRegistration(form, email) {
    if (registrationTracked) return;
    registrationTracked = true;
    const params = {content_name: 'Pre-BFCM 2026', content_category: form.id.includes('-hero-') ? 'hero' : 'steps', status: true};
    const eventID = `prebfcm-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    sendServerRegistration(eventID, email, params);
    let attempts = 0;
    (function send() {
      if (typeof window.fbq !== 'function') { if (++attempts < 20) setTimeout(send, 500); return; }
      window.fbq('set', 'userData', {em: email.toLowerCase()});
      window.fbq('track', 'CompleteRegistration', params, {eventID});
    })();
  }
  function initialize(root) {
    root.querySelectorAll('[data-klaviyo-signup]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const button = form.querySelector('button[type="submit"]');
      const input = form.querySelector('input[type="email"]');
      const status = form.querySelector('.gr-form-status');
      const originalLabel = button.textContent;
      button.disabled = false;
      let pending = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;
        pending = true;
        button.disabled = true;
        button.textContent = form.dataset.busy;
        form.setAttribute('aria-busy', 'true');
        status.hidden = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(form.dataset.companyId)}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15'},
            signal: controller.signal,
            body: JSON.stringify({data: {
              type: 'subscription',
              attributes: {
                custom_source: form.dataset.source || 'G&R BG | Pre-BFCM 2026 | Landing page V2',
                profile: {data: {type: 'profile', attributes: {
                  email: input.value.trim(),
                  locale: 'bg-BG',
                  properties: {pre_bfcm_campaign: '2026', pre_bfcm_variant: form.dataset.variant || '2', pre_bfcm_signup_page: location.pathname, pre_bfcm_form_placement: form.id.includes('-hero-') ? 'hero' : 'steps'},
                  subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
                }}}
              },
              relationships: {list: {data: {type: 'list', id: form.dataset.listId}}}
            }})
          });
          if (!response.ok) throw new Error('Subscription request failed');
          status.className = 'gr-form-status gr-form-success';
          status.textContent = form.dataset.success;
          form.querySelector('.gr-form-row').hidden = true;
          form.querySelector('.gr-form-note').hidden = true;
          form.dataset.submitted = 'true';
          trackRegistration(form, input.value.trim());
          document.dispatchEvent(new Event('gr:subscribed'));
        } catch (_error) {
          status.className = 'gr-form-status gr-form-error';
          status.textContent = form.dataset.error;
          button.disabled = false;
        } finally {
          clearTimeout(timeout);
          pending = false;
          form.removeAttribute('aria-busy');
          button.textContent = originalLabel;
          status.hidden = false;
          status.focus();
        }
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  // Mobile sticky return-to-form control: only the landing-page layout renders it.
  const sticky = document.querySelector('.gr-sticky-signup');
  const heroForm = document.querySelector('.gr-hero [data-klaviyo-signup]');
  if (!sticky || !heroForm) return;
  let subscribed = false;
  let scheduled = false;
  function updateSticky() {
    scheduled = false;
    const consentOpen = Array.from(document.querySelectorAll('[role="dialog"], #shopify-pc__banner, #shopify-pc__prefs')).some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    const formVisible = Array.from(document.querySelectorAll('[data-klaviyo-signup]')).some(el => { const rect = el.getBoundingClientRect(); return rect.bottom > 0 && rect.top < innerHeight; });
    const shouldHide = subscribed || innerWidth > 749 || heroForm.getBoundingClientRect().bottom > 0 || formVisible || consentOpen;
    if (sticky.hidden !== shouldHide) sticky.hidden = shouldHide;
  }
  function scheduleSticky() { if (!scheduled) { scheduled = true; requestAnimationFrame(updateSticky); } }
  document.addEventListener('gr:subscribed', () => { subscribed = true; updateSticky(); });
  document.querySelectorAll('[data-signup-jump]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    heroForm.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    heroForm.querySelector('input').focus({preventScroll: true});
  }));
  addEventListener('scroll', scheduleSticky, {passive:true});
  addEventListener('resize', scheduleSticky);
  new MutationObserver(scheduleSticky).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style','class','hidden']});
  updateSticky();
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
